import { Grid } from "@material-ui/core";
import { FunctionComponent } from "react";
import { countries } from "../../../../store/common/models";
import { UsersDTO } from "../../../../store/users/models/dto";
import { Label, StyledWidget } from "../common/components";

export const ContactDetails: FunctionComponent<{
  item: UsersDTO.Responses.GetSingle.T;
}> = ({ item }) => {
  const {
    streetAddress,
    city,
    zip,
    state,
    country,
    phoneCountryCode,
    phone,
  } = item;

  return (
    <StyledWidget title="Contact Details">
      <Grid container spacing={3}>
        <Grid item xs={3}>
          <Label>Street Address:</Label>
        </Grid>
        <Grid item xs={9}>
          {streetAddress}
        </Grid>
        <Grid item xs={3}>
          <Label>City:</Label>
        </Grid>
        <Grid item xs={3}>
          {city}
        </Grid>
        <Grid item xs={3}>
          <Label>ZIP:</Label>
        </Grid>
        <Grid item xs={3}>
          {zip}
        </Grid>
        <Grid item xs={3}>
          <Label>State:</Label>
        </Grid>
        <Grid item xs={3}>
          {state}
        </Grid>
        <Grid item xs={3}>
          <Label>Country:</Label>
        </Grid>
        <Grid item xs={3}>
          {countries.enum[country?.toUpperCase() as typeof countries.T]}
        </Grid>
        <Grid item xs={3}>
          <Label>Phone Country Code:</Label>
        </Grid>
        <Grid item xs={3}>
          {phoneCountryCode}
        </Grid>
        <Grid item xs={3}>
          <Label>Phone:</Label>
        </Grid>
        <Grid item xs={3}>
          {phone}
        </Grid>
      </Grid>
    </StyledWidget>
  );
};
